function defaultEquality(a, b) {
  return Object.is(a, b);
}
function jsonEquality(a, b) {
  return JSON.stringify(a) === JSON.stringify(b);
}
class ChangeDetector {
  constructor(equalityFn = defaultEquality) {
    this.values = /* @__PURE__ */ new Map();
    this.equalityFn = equalityFn;
  }
  /** Returns `true` if the value changed. */
  set(key, value, equalityFn) {
    const prev = this.values.get(key);
    const eq = equalityFn ?? this.equalityFn;
    if (this.values.has(key) && eq(prev, value)) {
      return false;
    }
    this.values.set(key, value);
    return true;
  }
  get(key) {
    return this.values.get(key);
  }
  has(key) {
    return this.values.has(key);
  }
  reset() {
    this.values.clear();
  }
}
function shallowEqual(a, b) {
  if (Object.is(a, b)) return true;
  if (typeof a !== "object" || typeof b !== "object" || a === null || b === null) return false;
  const keysA = Object.keys(a);
  const keysB = Object.keys(b);
  if (keysA.length !== keysB.length) return false;
  return keysA.every(
    (key) => Object.is(a[key], b[key])
  );
}
const ChangeDetectors = {
  /** Always changed — update on every set. */
  always: (_newVal, _oldVal) => true,
  /** Never changed — manual updates only. */
  never: (_newVal, _oldVal) => false,
  /** Deep structural comparison via JSON serialization. */
  deep: (newVal, oldVal) => JSON.stringify(newVal) !== JSON.stringify(oldVal),
  /** Shallow object comparison — compares own enumerable properties by reference. */
  shallow: (newVal, oldVal) => !shallowEqual(newVal, oldVal),
  /** Number threshold — only changed if difference exceeds epsilon. */
  threshold: (epsilon) => (newVal, oldVal) => Math.abs(newVal - oldVal) > epsilon
};
export {
  ChangeDetector,
  ChangeDetectors,
  defaultEquality,
  jsonEquality
};
//# sourceMappingURL=change-detection.js.map
